import { render, staticRenderFns } from "./newMaterialBox.vue?vue&type=template&id=6ed5939f&scoped=true&"
import script from "./newMaterialBox.vue?vue&type=script&lang=js&"
export * from "./newMaterialBox.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialBox.vue?vue&type=style&index=0&id=6ed5939f&lang=less&scoped=true&"
import style1 from "./newMaterialBox.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed5939f",
  null
  
)

component.options.__file = "newMaterialBox.vue"
export default component.exports